export const MeltdownHelper = {
  /* -----------------------------------------------
   ✅ Utils
  --------------------------------------------------*/
  escapeHtml(str) {
    return String(str ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  },

  // Sol altta toast zone
  getToastZone() {
    const $z = $("#meltdown-toast-zone");
    return $z.length ? $z : null;
  },

  // Form içi validation summary
  getInlineSummaryEl($form) {
    let $targets = $();

    // 1️⃣ Form içi ONLY .validationSummary
    if ($form?.length) {
      const $inForm = $form.find(".validationSummary");
      if ($inForm.length) $targets = $targets.add($inForm);
    }

    // 2️⃣ Global summary alanları (formdan bağımsız)
    const $global = $("#validationSummary, #validation-zone");
    if ($global.length) $targets = $targets.add($global);

    return $targets;
  },

  /* -----------------------------------------------
   ✅ Toast (premium DOM: meltdown-notify.css uyumlu)
  --------------------------------------------------*/
  toastVariant(kind) {
    // CSS: meltdown-toast--error|warn|info|success
    // ikonlar: bx
    if (kind === "warn") return { cls: "meltdown-toast--warn", icon: "bx bx-info-circle" };
    if (kind === "info") return { cls: "meltdown-toast--info", icon: "bx bx-info-circle" };
    if (kind === "success") return { cls: "meltdown-toast--success", icon: "bx bx-check-circle" };
    return { cls: "meltdown-toast--error", icon: "bx bx-error-circle" };
  },

  dismissToast($toast) {
    if (!$toast?.length) return;
    $toast.addClass("is-leaving");
    setTimeout(() => $toast.remove(), 180);
  },

  renderToast(payload) {
    const {
      kind = "error", // error|warn|info|success
      title = null,
      message = "",
      extraCount = 0,
      traceId = null,
      retryAfterSeconds = null,
      dedupeKey = null,
      durationMs = 4200, // 0 => kalıcı
      showClose = true,
      replaceAll = true,
    } = payload || {};

    // ✅ Merkezi Toast Sistemi Entegrasyonu
    // Eğer window.Toast veya Toast mevcutsa, yeni sistemi kullan.
    const globalToast = window.Toast || (typeof Toast !== "undefined" ? Toast : null);
    if (globalToast && (globalToast.error || globalToast.success)) {
      const type = kind === "success" ? "success" : kind === "info" || kind === "warn" ? "info" : "error";
      if (typeof globalToast[type] === "function") {
        globalToast[type](title || (type === "error" ? "Hata" : "Sistem"), message);
        return true;
      }
    }

    const $zone = this.getToastZone();
    if (!$zone) return null;

    const esc = (x) => this.escapeHtml(x);

    const key = dedupeKey || `${kind}:${String(message || "").toLowerCase()}`;
    const safeKey = typeof CSS !== "undefined" && CSS.escape ? CSS.escape(key) : key.replace(/"/g, "");

    const $existing = $zone.find(`[data-toast-key="${safeKey}"]`);
    const v = this.toastVariant(kind);

    const html = `
      <div class="meltdown-toast ${v.cls}" data-toast-key="${esc(key)}">
        <div class="meltdown-toast__bar"></div>
        <div class="meltdown-toast__inner">
          <span class="meltdown-toast__dot"></span>
          <i class="meltdown-toast__icon ${v.icon}"></i>

          <div class="meltdown-toast__body">
            ${title ? `<div class="meltdown-toast__title">${esc(title)}</div>` : ""}
            <div class="meltdown-toast__msg">${esc(message)}</div>

            ${
              extraCount || traceId || typeof retryAfterSeconds === "number"
                ? `
              <div class="meltdown-toast__meta">
                ${extraCount ? `<span class="meltdown-chip"><i class="bx bx-layer"></i>+${esc(extraCount)}</span>` : ""}

                ${
                  typeof retryAfterSeconds === "number"
                    ? `
                  <span class="meltdown-chip" data-retry-chip>
                    <i class="bx bx-time-five"></i>
                    <span data-retry-text>${esc(retryAfterSeconds)}s</span>
                  </span>`
                    : ""
                }

                ${
                  traceId
                    ? `
                  <span class="meltdown-chip">
                    <i class="bx bx-hash"></i>
                    <span class="meltdown-chip__truncate">${esc(traceId)}</span>
                  </span>`
                    : ""
                }
              </div>`
                : ""
            }
          </div>

          ${
            showClose
              ? `
            <button type="button" class="meltdown-toast__close" data-toast-close>
              <i class="bx bx-x"></i>
            </button>`
              : ""
          }
        </div>
      </div>
    `;

    let $toast;
    if ($existing.length) {
      $existing.replaceWith(html);
      $toast = $zone.find(`[data-toast-key="${safeKey}"]`);
    } else {
      if (replaceAll) $zone.empty();
      $zone.append(html);
      $toast = $zone.find(`[data-toast-key="${safeKey}"]`);
    }

    // close
    $toast.off("click.mdToast").on("click.mdToast", "[data-toast-close]", (e) => {
      e.preventDefault();
      this.dismissToast($toast);
    });

    // auto-hide
    if (durationMs && durationMs > 0) {
      const prev = $toast.data("mdTimer");
      if (prev) clearTimeout(prev);

      const t = setTimeout(() => this.dismissToast($toast), durationMs);
      $toast.data("mdTimer", t);
    }

    return $toast;
  },

  updateToastRetry(dedupeKey, remaining) {
    const $zone = this.getToastZone();
    if (!$zone) return;

    const safeKey = typeof CSS !== "undefined" && CSS.escape ? CSS.escape(dedupeKey) : dedupeKey.replace(/"/g, "");
    const $toast = $zone.find(`[data-toast-key="${safeKey}"]`);
    if ($toast.length) $toast.find("[data-retry-text]").text(`${remaining}s`);
  },

  /* -----------------------------------------------
   ✅ Inline Validation Summary List (form içinde)
  --------------------------------------------------*/
  renderValidationSummaryList($form, messages = [], opts = {}) {
    const $targets = this.getInlineSummaryEl($form);
    if (!$targets.length) return;

    const esc = (x) => this.escapeHtml(x);
    const list = (messages || []).map((m) => String(m || "").trim()).filter(Boolean);

    if (!list.length) {
      $targets.removeClass("active").empty();
      return;
    }

    const title = opts.title || "Lütfen hataları düzeltin";

    const html = `
    <div class="validationSummary__head">
      <i class="bx bx-error-circle"></i>
      <div class="validationSummary__title">${esc(title)}</div>
    </div>
    <div class="validationSummary__list">
      ${list
        .map(
          (m) => `
        <div class="validationSummary__item">
          <i class="bx bx-dot"></i>
          <span>${esc(m)}</span>
        </div>
      `,
        )
        .join("")}
    </div>
  `;

    $targets.html(html).addClass("active");
  },

  /* -----------------------------------------------
   🔸 Row Helpers
  --------------------------------------------------*/
  markRow(row, type = "default", message = "") {
    const $row = $(row);

    const defaultMessages = {
      passive: "Pasif Hale Getirildi",
      delete: "Veri Silindi",
      restore: "Aktif Edildi",
      finish: "Tamamlandı",
      approve: "Onaylandı",
      update: "Güncellendi",
      default: "İşlem Tamamlandı",
    };

    const defaultClasses = {
      passive: "td-passive",
      delete: "td-deleting",
      restore: "td-restore",
      finish: "td-finish",
      approve: "td-finish",
      update: "td-update",
      default: "td-default",
    };

    const msg = message || defaultMessages[type] || defaultMessages.default;
    const cls = defaultClasses[type] || defaultClasses.default;

    if (type === "update") {
      $row.addClass(cls);
      setTimeout(() => $row.removeClass(cls), 1500);
      return;
    }

    $row.empty().append(`<td colspan="999" class="${cls}">${this.escapeHtml(msg)}</td>`);
  },

  updateRowCell(row, cellIndex, value) {
    const $row = $(row);
    const $cell = $row.find("td").eq(cellIndex);
    if ($cell.length) $cell.html(value);
  },

  safe(val) {
    return val != null && val !== "" ? val : "-";
  },

  /* -----------------------------------------------
   🔒 Lock Form Submit (retryAfter) - toast countdown
  --------------------------------------------------*/
  lockFormSubmit(formSelector = "form", seconds = 0, opts = {}) {
    const $form = $(formSelector);
    if (!$form.length) return;

    const {
      submitSelector = `[type="submit"], button[data-action="submit"], [data-action="submit"], .js-submit`,
      showCountdown = true,
      lockClass = "is-locked",
      disableAllControls = true,
      excludeSelector = `[data-no-lock="true"]`,
      unlockForce = true,
      keepInputsEditable = true,
      toastKey = "retry-lock",
    } = opts;

    const prevTimer = $form.data("meltdownLockTimer");
    if (prevTimer) {
      clearInterval(prevTimer);
      $form.removeData("meltdownLockTimer");
    }

    $form.off(".meltdownLock");
    $form.addClass(lockClass);

    const $allControlsRaw = $form.find("input, select, textarea, button");
    const $allControls = excludeSelector ? $allControlsRaw.not(excludeSelector) : $allControlsRaw;

    const $submitLikeRaw = $form.find(submitSelector);
    const $submitLike = excludeSelector ? $submitLikeRaw.not(excludeSelector) : $submitLikeRaw;

    const $targets = keepInputsEditable ? $submitLike : disableAllControls ? $allControls : $submitLike;

    $targets.each(function () {
      const $el = $(this);
      if ($el.data("meltdownWasDisabled") === undefined) {
        $el.data("meltdownWasDisabled", $el.prop("disabled") === true);
      }
    });

    $targets.each(function () {
      const el = this;
      const $el = $(el);
      $el.prop("disabled", true);
      el.setAttribute("disabled", "");
      $el.attr("aria-disabled", "true");
    });
    const self = this;

    $form.on("submit.meltdownLock", function (e) {
      if ($(this).hasClass(lockClass)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    });

    $form.on("click.meltdownLock", submitSelector, function (e) {
      if ($form.hasClass(lockClass)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        self.renderToast({
          kind: "warn",
          title: "Lütfen bekleyin",
          message: "Tekrar deneme için süre dolmalı.",
          durationMs: 4200,
          dedupeKey: toastKey,
          replaceAll: false,
          showClose: true,
        });

        return false;
      }
    });

    let remaining = Math.max(0, Number(seconds) || 0);
    let isGlobalToast = false;

    const renderCountdown = () => {
      if (!showCountdown) return;

      if (!isGlobalToast) {
        // kalıcı warn toast
        const result = this.renderToast({
          kind: "warn",
          title: "Lütfen bekleyin",
          message: "Tekrar deneme için süre dolmalı.",
          retryAfterSeconds: remaining,
          durationMs: 0,
          dedupeKey: toastKey,
          replaceAll: false,
          showClose: true,
        });
        
        if (result === true) {
          isGlobalToast = true;
        }
      }

      if (!isGlobalToast) {
        this.updateToastRetry(toastKey, remaining);
      }
    };

    renderCountdown();

    const timer = setInterval(() => {
      remaining -= 1;

      if (remaining <= 0) {
        clearInterval(timer);
        $form.removeData("meltdownLockTimer");
        $form.off(".meltdownLock");

        $targets.each(function () {
          const el = this;
          const $el = $(el);

          if (unlockForce) {
            $el.prop("disabled", false);
            el.removeAttribute("disabled");
            $el.removeAttr("aria-disabled");
          } else {
            const wasDisabled = $el.data("meltdownWasDisabled") === true;
            if (!wasDisabled) {
              $el.prop("disabled", false);
              el.removeAttribute("disabled");
              $el.removeAttr("aria-disabled");
            }
          }

          $el.removeData("meltdownWasDisabled");
        });

        $form.removeClass(lockClass);

        // countdown toast kapat
        const $zone = this.getToastZone();
        if ($zone) {
          const safeKey = typeof CSS !== "undefined" && CSS.escape ? CSS.escape(toastKey) : toastKey.replace(/"/g, "");
          const $t = $zone.find(`[data-toast-key="${safeKey}"]`);
          if ($t.length) this.dismissToast($t);
        }

        return;
      }

      renderCountdown();
    }, 1000);

    $form.data("meltdownLockTimer", timer);
  },

  /* -----------------------------------------------
   🔸 Error Normalize
  --------------------------------------------------*/
  normalizeApiError(xhr) {
    const status = xhr?.status ?? 0;
    const json = xhr?.responseJSON ?? null;

    const out = {
      status,
      code: null,
      message: null,
      errors: [],
      validationErrors: [], // ✅ Yeni: validation hataları ayrı
      traceId: null,
      retryAfterSeconds: null,
      rawText: xhr?.responseText ?? "",
    };

    if (!json) {
      if (status === 0) {
        out.message = "Sunucuya ulaşılamadı. İnternet/VPN/Proxy kontrol edin.";
        return out;
      }
      if (status === 404) out.message = "İstenen kayıt veya sayfa bulunamadı.";
      else if (status === 401 || status === 403) out.message = "Bu işlem için yetkiniz bulunmuyor.";
      else if (status === 408) out.message = "İşlem zaman aşımına uğradı.";
      else if (status >= 500) out.message = "Sunucuda beklenmeyen bir hata oluştu.";
      else out.message = xhr?.statusText || "İşlem sırasında bir hata oluştu.";
      return out;
    }

    out.code = json.code ?? json.Code ?? json.errorCode ?? json.ErrorCode ?? null;
    out.message =
      json.message ??
      json.Message ??
      json.error ??
      json.Error ??
      json.title ??
      json.Title ??
      json.detail ??
      json.Detail ??
      (typeof json === "string" ? json : null);

    out.traceId = json.traceId ?? json.TraceId ?? json.traceID ?? json.TraceID ?? null;
    out.retryAfterSeconds = json.retryAfterSeconds ?? json.RetryAfterSeconds ?? null;

    // ✅ 1) validationErrors (Form validation)
    const valErrors = json.validationErrors ?? json.ValidationErrors;
    if (valErrors && typeof valErrors === "object") {
      if (Array.isArray(valErrors)) {
        // Array formatı: [{propertyName, errorMessage}, ...]
        valErrors.forEach((item) => {
          if (item && typeof item === "object") {
            const prop = item.propertyName ?? item.PropertyName ?? item.field ?? "";
            const msg = item.errorMessage ?? item.ErrorMessage ?? item.message ?? "";
            if (msg) {
              out.validationErrors.push({ propertyName: String(prop), errorMessage: String(msg) });
            }
          }
        });
      } else {
        // Object formatı: {PropertyName: ["error1", "error2"], ...}
        Object.entries(valErrors).forEach(([key, val]) => {
          const arr = Array.isArray(val) ? val : [String(val)];
          arr.forEach((m) => {
            out.validationErrors.push({ propertyName: key, errorMessage: String(m) });
          });
        });
      }
    }

    // ✅ 2) errors (Genel hatalar)
    const rawErrors = json.errors ?? json.Errors;
    if (Array.isArray(rawErrors)) {
      if (rawErrors.every((x) => typeof x === "string")) {
        // String array: ["error1", "error2"]
        out.errors = rawErrors.map((m) => ({ propertyName: "", errorMessage: m }));
      } else {
        // Object array: [{propertyName, errorMessage}, ...]
        out.errors = rawErrors
          .filter((e) => e && typeof e === "object")
          .map((e) => {
            const prop = e.propertyName ?? e.PropertyName ?? e.field ?? e.Field ?? e.key ?? e.Key ?? "";
            const msg = e.errorMessage ?? e.ErrorMessage ?? e.message ?? e.Message ?? e.title ?? e.Title ?? "";
            return { propertyName: String(prop), errorMessage: String(msg) };
          })
          .filter((e) => e.errorMessage);
      }
    }

    // Message yoksa validationErrors veya errors'tan al
    if (!out.message) {
      if (out.validationErrors.length) {
        out.message = out.validationErrors[0].errorMessage;
      } else if (out.errors.length) {
        out.message = out.errors[0].errorMessage;
      }
    }

    return out;
  },

  parseAjaxError(xhr) {
    const n = this.normalizeApiError(xhr);
    let msg = n.message || "-";

    const text = (n.rawText || "").trim();
    if ((!n.message || n.message === "-") && text) {
      if (/<html/i.test(text) || /<!DOCTYPE/i.test(text)) {
        msg = "Sunucudan geçersiz yanıt alındı.";
      } else if (text.startsWith("{") && text.endsWith("}")) {
        try {
          const parsed = JSON.parse(text);
          msg = parsed.message || parsed.error || parsed.title || msg;
        } catch {
          // ignore
        }
      } else {
        msg = text.length > 200 ? text.slice(0, 200) + "..." : text;
      }
    }

    if (n.traceId) msg += ` (TraceId: ${n.traceId})`;
    if (typeof n.retryAfterSeconds === "number") msg += ` (Tekrar dene: ${n.retryAfterSeconds}s)`;

    return msg;
  },

  /* -----------------------------------------------
   ✅ Validation Handler (2 kanal)
   - Field errors: input altı span’lere
   - validationSummary: form içinde list
   - Toast: genel hata / auth / server / retry
  --------------------------------------------------*/
  handleValidationErrors(
    xhr,
    formSelector = "form",
    opts = {
      mode: "all",
      dedupe: true,
      showMeta: false,
      showToast: true,
      showInline: true,
      showField: true,
      focusFirstError: true, // ✅ Yeni: ilk hataya focus
    },
  ) {
    const $form = $(formSelector);
    const n = this.normalizeApiError(xhr);

    // Temizlik (field)
    $form.find("span.validation-text").text("");
    $form.find(".form-control").removeClass("form-validation-error form-validation-success");
    $form.find("input, select, textarea").removeClass("input-validation-error").removeAttr("aria-invalid");

    // Inline summary temizle
    const $inline = this.getInlineSummaryEl($form);
    if ($inline.length) $inline.removeClass("active").empty();

    const mode = opts?.mode ?? "all";
    const showField = opts?.showField ?? true;
    const showInline = opts?.showInline ?? true;
    const showToast = opts?.showToast ?? true;
    const showMeta = opts?.showMeta ?? false;
    const dedupe = opts?.dedupe ?? true;
    const focusFirstError = opts?.focusFirstError ?? true;

    const allowField = mode === "all" || mode === "validationOnly";
    const allowToast = mode === "all" || mode === "messageOnly" || mode === "validationOnly";

    // ✅ validationErrors ve errors'ı birleştir
    let allErrors = [];

    if (mode !== "messageOnly") {
      // Önce validationErrors (form hataları)
      if (Array.isArray(n.validationErrors)) {
        allErrors = [...n.validationErrors];
      }

      // Sonra genel errors (sadece validationOnly değilse)
      if (mode !== "validationOnly" && Array.isArray(n.errors)) {
        allErrors = [...allErrors, ...n.errors];
      }
    }

    if (mode === "validationOnly") {
      allErrors = allErrors.filter((e) => String(e?.propertyName || "").trim().length > 0);
    }

    if (mode === "all" && !allErrors.length && n.message) {
      allErrors = [{ propertyName: "", errorMessage: n.message }];
    }

    const seen = new Set();
    const summaryMessages = [];
    let firstErrorInput = null; // ✅ İlk hatalı input

    const addMsg = (msg) => {
      msg = String(msg || "").trim();
      if (!msg) return false;
      if (dedupe) {
        const key = msg.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
      }
      summaryMessages.push(msg);
      return true;
    };

    // 1) Errors varsa
    if (allErrors.length) {
      const errorProps = allErrors.map((e) => e.propertyName).filter(Boolean);

      allErrors.forEach(({ propertyName, errorMessage }) => {
        const msg = String(errorMessage || "").trim();
        if (!msg) return;

        // Field render
        if (propertyName && allowField && showField) {
          let $errorSpan = $form.find(`span[data-valmsg-for="${propertyName}"]`);

          // Case-insensitive fallback for span
          if (!$errorSpan.length) {
            $errorSpan = $form.find(`span[data-valmsg-for="${propertyName.toLowerCase()}"]`);
          }

          if ($errorSpan.length) {
            $errorSpan.text(msg);

            const $formControl = $errorSpan.closest(".form-control");
            $formControl.addClass("form-validation-error");

            let $input = $form.find(`[name="${propertyName}"]`).first();
            // Case-insensitive fallback
            if (!$input.length) {
              $input = $form.find(`[name="${propertyName.toLowerCase()}"]`).first();
            }

            if ($input.length) {
              $input.addClass("input-validation-error").attr("aria-invalid", "true");

              // ✅ İlk hatalı input'u kaydet
              if (!firstErrorInput) {
                firstErrorInput = $input;
              }
            }
          }
        }

        addMsg(msg);
      });

      // ✅ İlk hatalı input'a focus
      if (focusFirstError && firstErrorInput && firstErrorInput.length) {
        setTimeout(() => {
          firstErrorInput.focus();

          // Scroll to view
          const offset = firstErrorInput.offset();
          if (offset) {
            $("html, body").animate(
              {
                scrollTop: offset.top - 100,
              },
              300,
            );
          }
        }, 100);
      }

      // ✅ Inline validation list (form içinde)
      if (showInline && mode !== "messageOnly") {
        const inlineList = summaryMessages.filter(Boolean);
        this.renderValidationSummaryList($form, inlineList, { title: "Lütfen hataları düzeltin" });
      }

      // ✅ Toast (genel)
      if (showToast && allowToast) {
        const toastKind = n.status === 429 ? "warn" : "error";
        const hasFieldErrors = errorProps.length > 0 || summaryMessages.length > 0;

        // Öncelik Sırası:
        // 1. n.message (Sunucu ana mesajı) - "İşlem başarısız" gibi jenerik değilse
        // 2. summaryMessages[0] (İlk detaylı hata)
        // 3. "Formda hatalar var." (Son fallback)
        let mainMsg = n.message;
        const isGeneric = !mainMsg || mainMsg === "İşlem başarısız." || mainMsg === "İşlem başarısız";

        if (isGeneric && summaryMessages.length > 0) {
          mainMsg = summaryMessages[0];
        } else if (!mainMsg) {
          mainMsg = hasFieldErrors ? "Formda hatalar var." : "İşlem başarısız.";
        }

        this.renderToast({
          kind: toastKind,
          title: opts.title || (toastKind === "warn" ? "Uyarı" : "Hata"),
          message: mainMsg,
          extraCount: hasFieldErrors ? Math.max(0, summaryMessages.length - (isGeneric ? 1 : 0)) : 0,
          traceId: showMeta ? n.traceId : null,
          retryAfterSeconds: showMeta ? n.retryAfterSeconds : null,
          durationMs: n.status === 429 ? 0 : 4200,
          dedupeKey: `${toastKind}:${n.status || 0}:${n.code || ""}:${mainMsg}`,
          replaceAll: true,
        });
      }

      // ✅ Success state (diğer alanlar)
      if (allowField && showField && errorProps.length) {
        $form.find("span.validation-text").each(function () {
          const propName = $(this).attr("data-valmsg-for");
          if (!propName) return;

          let $input = $form.find(`[name="${propName}"]`).first();
          if (!$input.length) {
            $input = $form.find(`[name="${propName.toLowerCase()}"]`).first();
          }

          const $formControl = $(this).closest(".form-control");
          const value = ($input.val() ?? "").toString().trim();

          if (!errorProps.includes(propName)) {
            const isRequired =
              $input.length && ($input.is("[required]") || $input.attr("data-val-required") !== undefined);
            if (isRequired || value.length > 0) $formControl.addClass("form-validation-success");
          }
        });
      }

      return;
    }

    // 2) errors yok -> message (genel hata)
    if (mode !== "validationOnly" && n.message) {
      if (showInline && mode !== "messageOnly") {
        this.renderValidationSummaryList($form, [n.message], { title: "İşlem başarısız" });
      }

      if (showToast && allowToast) {
        const toastKind = n.status === 429 ? "warn" : "error";

        this.renderToast({
          kind: toastKind,
          title: toastKind === "warn" ? "Uyarı" : "Hata",
          message: n.message,
          traceId: showMeta ? n.traceId : null,
          retryAfterSeconds: showMeta ? n.retryAfterSeconds : null,
          durationMs: n.status === 429 ? 0 : 4200,
          dedupeKey: `${toastKind}:${n.status || 0}:${n.code || ""}:${n.message}`,
          replaceAll: true,
        });
      }

      return;
    }

    // 3) hiç hata yok -> success state
    $form.find(".form-control").each(function () {
      const $formControl = $(this);
      const $input = $formControl.find("input, select, textarea").first();
      const value = ($input.val() ?? "").toString().trim();
      const isRequired = $input.is("[required]") || $input.attr("data-val-required") !== undefined;
      if (isRequired || value.length > 0) $formControl.addClass("form-validation-success");
    });
  },

  /* -----------------------------------------------
   🔸 Tabs
  --------------------------------------------------*/
  handleTabErrorNavigation($form) {
    const invalidElements = $form.find(".input-validation-error, [aria-invalid='true']");
    const firstInvalidElement = invalidElements.first();

    if (!firstInvalidElement.length) {
      $(".meltdown-tabs .tab-button").removeClass("tabs-error");
      return;
    }

    let firstInvalidTabId = null;

    invalidElements.each(function () {
      const tabContent = $(this).closest(".tab-content");
      if (tabContent.length) {
        const tabId = tabContent.attr("id");
        const tabButton = $(`.meltdown-tabs .tab-button[data-tab='${tabId}']`);
        tabButton.addClass("tabs-error");
        if (firstInvalidTabId === null) firstInvalidTabId = tabId;
      }
    });

    if (firstInvalidTabId) {
      $(".meltdown-tab-contents .tab-content, .meltdown-tabs .tab-button").removeClass("active");
      $(`#${firstInvalidTabId}`).addClass("active");
      $(`.meltdown-tabs .tab-button[data-tab='${firstInvalidTabId}']`).addClass("active");
      firstInvalidElement.focus();
    }
  },

  /* -----------------------------------------------
   ✅ Submit Validation Orchestrator
  --------------------------------------------------*/
  handleSubmitValidation(xhr, formSelector = "form", opts = {}) {
    const n = this.normalizeApiError(xhr);

    console.group("❌ Validation/Error Response");
    console.log("Status:", n.status);
    console.log("Code:", n.code);
    console.log("Message:", n.message);
    console.log("Validation Errors:", n.validationErrors); // ✅ Yeni
    console.log("General Errors:", n.errors); // ✅ Güncellendi
    console.log("TraceId:", n.traceId);
    console.log("RetryAfterSeconds:", n.retryAfterSeconds);
    console.log("Raw XHR:", xhr);
    console.groupEnd();

    const $form = $(formSelector);

    // ✅ Validation hatası varsa validationOnly, yoksa mode'a göre karar ver
    const hasValidationErrors = n.validationErrors && n.validationErrors.length > 0;
    const hasGeneralErrors = n.errors && n.errors.length > 0;

    let defaultMode = "all";

    // AUTH_FAILED/401 -> Sadece toast değil, alanı da göstersin istiyoruz (focus için)
    if (n.code === "AUTH_FAILED" || n.status === 401) {
      defaultMode = "all";
    }
    // Sadece validation hatası varsa -> validationOnly (genel hataları toast'a basma)
    else if (hasValidationErrors && !hasGeneralErrors) {
      defaultMode = "validationOnly";
    }
    // Hem validation hem genel hata varsa -> all (ikisini de göster)
    else if (hasValidationErrors && hasGeneralErrors) {
      defaultMode = "all";
    }

    const merged = {
      mode: defaultMode,
      dedupe: true,
      title: opts.title || opts.validation?.title,
      showMeta: false,
      showToast: true,
      showInline: true,
      showField: true,
      focusFirstError: true,
      ...(opts.validation || {}),
    };

    this.handleValidationErrors(xhr, formSelector, merged);
    this.handleTabErrorNavigation($form);

    if (typeof n.retryAfterSeconds === "number" && n.retryAfterSeconds > 0) {
      this.lockFormSubmit(formSelector, n.retryAfterSeconds, {
        keepInputsEditable: true,
        showCountdown: true,
        ...(opts.lock || {}),
      });
    }
  },

  /* -----------------------------------------------
   🔸 Reset
  --------------------------------------------------*/
  resetValidation(formSelector = "form", update = false) {
    const $form = $(formSelector);

    $form.find("span.validation-text").text("");
    $form.find(".form-control").removeClass("form-validation-error form-validation-success");
    $form.find("input, select, textarea").removeClass("input-validation-error").removeAttr("aria-invalid");

    // toast temizle
    const $zone = this.getToastZone();
    if ($zone) $zone.empty();

    // inline summary temizle
    const $inline = this.getInlineSummaryEl($form);
    if ($inline.length) $inline.empty().removeClass("active");

    if (!update) $form[0]?.reset();

    $form.removeData("validator");
    $form.removeData("unobtrusiveValidation");
    $.validator.unobtrusive.parse($form);
  },

  resetUnobtrusive(form) {
    const $form = $(form);
    if (!$form.length) return;

    const validator = $form.data("validator");
    if (validator) validator.resetForm();

    $form
      .find(".input-validation-error")
      .removeClass("input-validation-error")
      .addClass("valid")
      .attr("aria-invalid", "false");

    $form
      .find(".field-validation-error")
      .removeClass("field-validation-error")
      .addClass("field-validation-valid")
      .empty();

    $form
      .find("[data-valmsg-summary='true']")
      .removeClass("validation-summary-errors")
      .addClass("validation-summary-valid")
      .empty();

    $form.removeData("validator");
    $form.removeData("unobtrusiveValidation");
    $.validator.unobtrusive.parse($form);
  },

  /* -----------------------------------------------
   🔸 Flatpickr
  --------------------------------------------------*/
  // setupFlatpickrs(context = document) {
  //   try {
  //     const container = context && context.jquery ? context.get(0) : context;
  //     if (!container) return;
  //     setupFlatpickrs(container);
  //   } catch (err) {
  //     console.error("setupFlatpickrs hata:", err);
  //   }
  // },
};
